import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../Components/Component-css/Header.css";
import css from "./Component-css/Nav.module.css";
import { BsPeople } from "react-icons/bs";
import BottonMenu from "../uiComponents/BottonMenu";
import { BsWallet, BsGift } from "react-icons/bs";
import { IoMdNotificationsOutline } from "react-icons/io";
import { FiPlus } from "react-icons/fi";
import "../Components/Component-css/Header.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { LanguageContext } from "./LanguageContext";
import { useContext } from "react";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";
import { FaPlus } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";

const w3_close = () => {
  const sidebar = document.getElementById("mySidebar");
  const overlay = document.getElementById("sidebarOverlay");

  // सुनिश्चित करें कि Sidebar मौजूद है
  if (sidebar) {
    // अगर mySidebar मौजूद है, तभी उसकी width पढ़ें
    const width = sidebar.offsetWidth;
    sidebar.style.left = `-${width}px`;
  }

  // सुनिश्चित करें कि Overlay मौजूद है
  if (overlay) {
    overlay.style.display = "none";
  }
};

const w3_open = () => {
  const sidebar = document.getElementById("mySidebar");
  const overlay = document.getElementById("sidebarOverlay");

  // सुनिश्चित करें कि Sidebar और Overlay मौजूद हैं
  if (sidebar) {
    sidebar.style.left = "0";
  }
  if (overlay) {
    overlay.style.display = "block";
  }
};

const addsetting = localStorage.getItem("sitSetting");

const addCaseSetting = JSON.parse(addsetting);
const udata = localStorage.getItem("udata");
const profileData = JSON.parse(udata);

const Header = ({ user }) => {
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const [isdropdownVisible, setIsdropdownVisible] = useState(false);

  const toggleDiv = () => {
    setIsdropdownVisible(!isdropdownVisible);
  };

  const history = useHistory();

  let access_token = localStorage.getItem("token");
  access_token = localStorage.getItem("token");

  const logout = async () => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const respone = await apiRequest(`logout`, "POST", null, headers);

    localStorage.removeItem("token");
    window.location.reload();
    history.push("/");
  };
const [promptInstall, setPromptInstall] = useState(null);
const [supportsPWA, setSupportsPWA] = useState(false);
const [isAppInstalled, setIsAppInstalled] = useState(false);

useEffect(() => {
  // Check if app is already installed
  const checkInstalled = () => {
    const installed =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    setIsAppInstalled(installed);
  };

  checkInstalled();

  const handler = (e) => {
    e.preventDefault();

    // Agar already installed hai to button mat dikhana
    const installed =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    if (installed) {
      setIsAppInstalled(true);
      return;
    }

    setPromptInstall(e);
    setSupportsPWA(true);
  };

  window.addEventListener(
    "beforeinstallprompt",
    handler
  );

  // Install hone ke baad
  const handleAppInstalled = () => {
    console.log("PWA installed successfully");

    setIsAppInstalled(true);
    setSupportsPWA(false);
    setPromptInstall(null);
  };

  window.addEventListener(
    "appinstalled",
    handleAppInstalled
  );

  // Browser se app standalone mode me open ho
  const mediaQuery = window.matchMedia(
    "(display-mode: standalone)"
  );

  const handleDisplayModeChange = () => {
    checkInstalled();
  };

  mediaQuery.addEventListener(
    "change",
    handleDisplayModeChange
  );

  return () => {
    window.removeEventListener(
      "beforeinstallprompt",
      handler
    );

    window.removeEventListener(
      "appinstalled",
      handleAppInstalled
    );

    mediaQuery.removeEventListener(
      "change",
      handleDisplayModeChange
    );
  };
}, []);

const onClick = async (evt) => {
  evt.preventDefault();

  if (!promptInstall) return;

  try {
    promptInstall.prompt();

    const choiceResult =
      await promptInstall.userChoice;

    if (choiceResult.outcome === "accepted") {
      console.log("User accepted PWA install");

      setIsAppInstalled(true);
      setSupportsPWA(false);
    } else {
      console.log("User dismissed PWA install");
    }
  } catch (error) {
    console.error(
      "PWA install error:",
      error
    );
  }

  setPromptInstall(null);
};

  // language
  const { changeLanguage } = useContext(LanguageContext);
  const translations = {
    hi: {
      commission: "कमीशन: 5% : रेफरल: सभी खेलों के लिए 3%",
      profile: "मेरी प्रोफाइल",
      play: "खेले",
      wallet: "वॉलेट",
      refer: "रेफरल और कमाएँ",
      history: "इतिहास",
      support: "सहायता",
      // app: "ऐप डाउनलोड",
      kyc: "केवाईसी",
    },
    en: {
      commission: "COMMISSION: 5% : REFERRAL: 3% FOR ALL GAMES",
      profile: "My Profile",
      play: "Play",
      wallet: "My Wallet",
      refer: "Refer and Earn",
      referHist: "Refer History",
      history: "History",
      support: "Support",
      prizepool: "Prize Pool",
      referalpool: "Referal Prize",
      notify: "Notification",
      // app: " App ",
      kyc: "KYC",
      policy: "Policy",
    },
  };

  const { language } = useContext(LanguageContext);
  const t = translations[language] || translations.en;

  // change theme
  const { theme, toggleTheme } = useTheme("light");
  const theme1 = localStorage.getItem("theme");

  const styles = {
    backgroundColor: theme1 === "light" ? "#000" : "black",
    color: theme1 === "light" ? "#fff" : "#fff",
  };
  const styles1 = {
    backgroundColor: theme1 === "light" ? "#fff" : "#6c757d",
    color: theme1 === "light" ? "black !important" : "#fff !important",
  };
  const logo = theme1 === "light" ? "/joker.png" : "/joker.png";

  const colorChange = () => {
    localStorage.setItem("theme", "#fff");
    toggleTheme("#fff");
  };

  useEffect(() => {
    localStorage.setItem("theme", "light");
  }, []);

  return (
    <>
      <div>
        {access_token ? (
          <React.Fragment>
            <div id="sidebarOverlay" onClick={w3_close}></div>
            <div className="max-custom-sidebar" id="mySidebar">
              <div className="sidebar-links-container">
                {/* 1. My Profile */}
                <Link
                  to={"/Profile"}
                  className="sidebar-nav-row"
                  onClick={w3_close}
                >
                  <div className="sidebar-row-icon">
                    <img
                      src="/images/avatars/Avatar7.png"
                      alt="Profile"
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <span className="sidebar-row-title">My Profile</span>
                </Link>

                {/* 2. Win cash (Highlight / Light Grey Row) */}
                <Link
                  to={"/Homepage/ludoClassicManual"}
                  className="sidebar-nav-row highlight-row"
                  onClick={w3_close}
                >
                  <div className="sidebar-row-icon">
                    <img
                      src="/images/refer/gamepad.png"
                      alt="Win cash"
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <span className="sidebar-row-title">Win cash</span>
                </Link>

                {/* 3. My wallet */}
                <Link
                  to={"/wallet"}
                  className="sidebar-nav-row"
                  onClick={w3_close}
                >
                  <div className="sidebar-row-icon">
                    <img
                      src="/images/refer/wallet.png"
                      alt="My wallet"
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <span className="sidebar-row-title">My wallet</span>
                </Link>

                {/* 4. History (Highlight / Light Grey Row) */}
                <Link
                  to={"/history"}
                  className="sidebar-nav-row highlight-row"
                  onClick={w3_close}
                >
                  <div className="sidebar-row-icon">
                    <img
                      src="/images/refer/order-history.png"
                      alt="History"
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <span className="sidebar-row-title">History</span>
                </Link>

                {/* 5. Refer History */}
                <Link
                  to={"/Referral-history"}
                  className="sidebar-nav-row"
                  onClick={w3_close}
                >
                  <div className="sidebar-row-icon">
                    <img
                      src="/images/refer/refer-history.webp"
                      alt="Refer History"
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <span className="sidebar-row-title">Refer History</span>
                </Link>

                {/* 6. Refer and Earn (Highlight / Light Grey Row) */}
                {addCaseSetting?.isReferral && (
                  <Link
                    to={"/refer"}
                    className="sidebar-nav-row highlight-row"
                    onClick={w3_close}
                  >
                    <div className="sidebar-row-icon">
                      <img
                        src="/images/refer/sreferEarn.png"
                        alt="Refer and Earn"
                        style={{
                          width: "24px",
                          height: "24px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <span className="sidebar-row-title">Refer and Earn</span>
                  </Link>
                )}

                {/* 7. Notification */}
                <Link
                  to={"/Notification"}
                  className="sidebar-nav-row"
                  onClick={w3_close}
                >
                  <div className="sidebar-row-icon">
                    <img
                      src="/images/refer/notifications.png"
                      alt="Notification"
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <span className="sidebar-row-title">Notification</span>
                </Link>

                {/* 8. Support (Highlight / Light Grey Row) */}
                <Link
                  to={"/support"}
                  className="sidebar-nav-row highlight-row"
                  onClick={w3_close}
                >
                  <div className="sidebar-row-icon">
                    <img
                      src="/images/refer/support.png"
                      alt="Support"
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <span className="sidebar-row-title">Support</span>
                </Link>

                {/* 9. All Policy / Policy Dropdown */}
                <div className="sidebar-nav-row" onClick={toggleDiv}>
                  <div className="sidebar-row-icon">
                    <img
                      src="/images/refer/grey.png"
                      alt="All Policy"
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <span className="sidebar-row-title">All Policy</span>
                </div>

                {isdropdownVisible && (
                  <ul className="sidebar-sub-policy-list">
                    <li>
                      <Link to="/privacy-policy" onClick={w3_close}>
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/term-condition" onClick={w3_close}>
                        Terms &amp; Condition
                      </Link>
                    </li>
                    <li>
                      <Link to="/tds-policy" onClick={w3_close}>
                        TDS Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/responsible-gaming" onClick={w3_close}>
                        Responsible Gaming
                      </Link>
                    </li>
                    <li>
                      <Link to="/about" onClick={w3_close}>
                        About
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact-us" onClick={w3_close}>
                        Contact
                      </Link>
                    </li>
                  </ul>
                )}
              </div>
            </div>
            <div className="max-top-header-bar">
              <div className="header-left-group">
                <button
                  className="hamburger-menu-btn"
                  onClick={w3_open}
                  id="hambergar"
                >
                  <div className="hamburger-lines">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </button>

                <Link
                  to="/"
                  className="header-logo-link"
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src="/joker.png"
                    alt="JOKERLUDO"
                    style={{
                      width: "77px",
                      height: "auto",
                      maxHeight: "58px",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                </Link>
              </div>
              {/* =================================================
                  APP DOWNLOAD BUTTON
                  ONLY SHOW WHEN NOT INSTALLED
              ================================================= */}

              {supportsPWA && !isAppInstalled && promptInstall && (
                <button
                  type="button"
                  className="modern-app-download-btn"
                  onClick={onClick}
                  aria-label="Install App"
                  title="Install App"
                >
                  <div className="app-btn-content">
                    <span className="bouncing-arrow">↓</span>

                    <span className="app-text">App</span>
                  </div>
                </button>
              )}
              <div className="header-right-group">
                {/* CASH WALLET PILL */}
                <NavLink
                  exact
                  to="/Addcase"
                  className="wallet-chip-pill cash-pill"
                >
                  <span className="pill-icon">💵</span>
                  <div className="pill-text-col">
                    <span className="pill-small-label">Cash</span>
                    <span className="pill-val-num">
                      {user && user?.Wallet_balance !== undefined
                        ? user.Wallet_balance
                        : 0}
                    </span>
                  </div>
                </NavLink>

                {/* EARN / REFERRAL WALLET PILL */}
                <NavLink
                  exact
                  to="/redeem/refer"
                  className="wallet-chip-pill earn-pill"
                >
                  <span className="pill-icon pink-bag">💰</span>
                  <div className="pill-text-col">
                    <span className="pill-small-label">Earn</span>
                    <span className="pill-val-num">
                      {user && user?.referral_wallet !== undefined
                        ? user.referral_wallet.toFixed(2)
                        : 0}
                    </span>
                  </div>
                </NavLink>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="w3-teal " style={styles}>
            <div className="w3-container ">
              <div className={`${css.headerContainer} justify-content-between`}>
                <Link to="/">
                  <picture className={`ml-2 ${css.navLogo} d-flex`}>
                    <img
                      src="/joker.png"
                      className="snip-img"
                      alt="STARKINGADDA"
                      width="30px"
                    />
                  </picture>
                </Link>

                <div className={`ml-5`}>
                  <Link type="button" className="login-btn" to="/login">
                    LOGIN
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="bottom_menus_main">
        <BottonMenu w3_close={w3_close} />
      </div>
    </>
  );
};

export default Header;

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Link, NavLink, useHistory } from "react-router-dom";
// import { FaArrowLeft } from "react-icons/fa";
// import "../Components/Component-css/Header.css";
// import css from "./Component-css/Nav.module.css";
// import { BsPeople } from "react-icons/bs";
// import BottonMenu from "../uiComponents/BottonMenu";
// import { BsWallet, BsGift } from "react-icons/bs";
// import { IoMdNotificationsOutline } from "react-icons/io";
// import { FiPlus } from "react-icons/fi";
// import { GiHamburgerMenu } from "react-icons/gi";
// import { LanguageContext } from "./LanguageContext";
// import { useContext } from "react";
// import { useTheme } from "../../ThemeContext";
// import { apiRequest } from "../../apiService/allApi";
// import { FaPlus } from "react-icons/fa";
// import { FaUsers } from "react-icons/fa6";

// const w3_close = () => {
//   const sidebar = document.getElementById("mySidebar");
//   const overlay = document.getElementById("sidebarOverlay");

//   if (sidebar) {
//     const width = sidebar.offsetWidth;
//     sidebar.style.left = `-${width}px`;
//   }

//   if (overlay) {
//     overlay.style.display = "none";
//   }
// };

// const w3_open = () => {
//   const sidebar = document.getElementById("mySidebar");
//   const overlay = document.getElementById("sidebarOverlay");

//   if (sidebar) {
//     sidebar.style.left = "0";
//   }

//   if (overlay) {
//     overlay.style.display = "block";
//   }
// };

// const addsetting = localStorage.getItem("sitSetting");
// const addCaseSetting = JSON.parse(addsetting || "{}");

// const udata = localStorage.getItem("udata");
// const profileData = JSON.parse(udata || "{}");

// const Header = ({ user }) => {
//   const beckendLocalApiUrl =
//     process.env.REACT_APP_BACKEND_LOCAL_API;

//   const beckendLiveApiUrl =
//     process.env.REACT_APP_BACKEND_LOCAL_API;

//   const nodeMode = process.env.NODE_ENV;

//   let baseUrl =
//     nodeMode === "development"
//       ? beckendLocalApiUrl
//       : beckendLiveApiUrl;

//   const [isdropdownVisible, setIsdropdownVisible] =
//     useState(false);

//   const toggleDiv = () =>
//     setIsdropdownVisible(!isdropdownVisible);

//   const history = useHistory();

//   let access_token = localStorage.getItem("token");

//   const logout = async () => {
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };

//     await apiRequest(
//       `logout`,
//       "POST",
//       null,
//       headers
//     );

//     localStorage.removeItem("token");

//     window.location.reload();

//     history.push("/");
//   };

//   /* =========================================================
//      PWA INSTALL STATES
//   ========================================================= */

//   const [promptInstall, setPromptInstall] =
//     useState(null);

//   const [supportsPWA, setSupportsPWA] =
//     useState(false);

//   const [isAppInstalled, setIsAppInstalled] =
//     useState(false);

//   /* =========================================================
//      CHECK PWA INSTALL STATUS
//   ========================================================= */

//   useEffect(() => {
//     const checkAppInstalled = () => {
//       const isStandalone =
//         window.matchMedia(
//           "(display-mode: standalone)"
//         ).matches ||
//         window.navigator.standalone === true;

//       setIsAppInstalled(isStandalone);

//       if (isStandalone) {
//         setSupportsPWA(false);
//         setPromptInstall(null);
//       }
//     };

//     checkAppInstalled();

//     /* Chrome / Edge install event */
//     const handleBeforeInstallPrompt = (event) => {
//       event.preventDefault();

//       const alreadyInstalled =
//         window.matchMedia(
//           "(display-mode: standalone)"
//         ).matches ||
//         window.navigator.standalone === true;

//       if (alreadyInstalled) {
//         setIsAppInstalled(true);
//         setSupportsPWA(false);
//         setPromptInstall(null);
//         return;
//       }

//       setPromptInstall(event);
//       setSupportsPWA(true);
//       setIsAppInstalled(false);
//     };

//     /* Fired after successful installation */
//     const handleAppInstalled = () => {
//       console.log("PWA installed successfully");

//       setIsAppInstalled(true);
//       setSupportsPWA(false);
//       setPromptInstall(null);
//     };

//     window.addEventListener(
//       "beforeinstallprompt",
//       handleBeforeInstallPrompt
//     );

//     window.addEventListener(
//       "appinstalled",
//       handleAppInstalled
//     );

//     /* Detect standalone mode changes */
//     const displayModeMedia =
//       window.matchMedia(
//         "(display-mode: standalone)"
//       );

//     const handleDisplayModeChange = () => {
//       checkAppInstalled();
//     };

//     if (displayModeMedia.addEventListener) {
//       displayModeMedia.addEventListener(
//         "change",
//         handleDisplayModeChange
//       );
//     }

//     return () => {
//       window.removeEventListener(
//         "beforeinstallprompt",
//         handleBeforeInstallPrompt
//       );

//       window.removeEventListener(
//         "appinstalled",
//         handleAppInstalled
//       );

//       if (displayModeMedia.removeEventListener) {
//         displayModeMedia.removeEventListener(
//           "change",
//           handleDisplayModeChange
//         );
//       }
//     };
//   }, []);

//   /* =========================================================
//      INSTALL APP
//   ========================================================= */

//   const onClick = async (event) => {
//     event.preventDefault();

//     if (!promptInstall) {
//       return;
//     }

//     try {
//       promptInstall.prompt();

//       const choiceResult =
//         await promptInstall.userChoice;

//       if (
//         choiceResult &&
//         choiceResult.outcome === "accepted"
//       ) {
//         console.log("User accepted PWA install");

//         setIsAppInstalled(true);
//         setSupportsPWA(false);
//         setPromptInstall(null);
//       } else {
//         console.log("User dismissed PWA install");

//         setPromptInstall(null);
//       }
//     } catch (error) {
//       console.error(
//         "PWA installation error:",
//         error
//       );

//       setPromptInstall(null);
//     }
//   };

//   const { language } =
//     useContext(LanguageContext);

//   const translations = {
//     hi: {
//       profile: "मेरी प्रोफाइल",
//       wallet: "वॉलेट",
//     },
//     en: {
//       profile: "My Profile",
//       wallet: "My Wallet",
//     },
//   };

//   const t =
//     translations[language] ||
//     translations.en;

//   const { theme, toggleTheme } =
//     useTheme("light");

//   const theme1 =
//     localStorage.getItem("theme");

//   const styles = {
//     backgroundColor:
//       theme1 === "light"
//         ? "#000"
//         : "black",
//     color: "#fff",
//   };

//   useEffect(() => {
//     localStorage.setItem(
//       "theme",
//       "light"
//     );
//   }, []);

//   return (
//     <>
//       <div>
//         {access_token ? (
//           <React.Fragment>

//             <div
//               id="sidebarOverlay"
//               onClick={w3_close}
//             ></div>

//             <div
//               className="max-custom-sidebar"
//               id="mySidebar"
//             >
//               {/* Sidebar content */}
//             </div>

//             {/* =================================================
//                 TOP HEADER BAR
//             ================================================= */}

//             <div className="max-top-header-bar">

//               {/* LEFT SIDE */}
//               <div className="header-left-group">

//                 <button
//                   className="hamburger-menu-btn"
//                   onClick={w3_open}
//                   id="hambergar"
//                 >
//                   <div className="hamburger-lines">
//                     <span></span>
//                     <span></span>
//                     <span></span>
//                   </div>
//                 </button>

//                 <Link
//                   to="/"
//                   className="header-logo-link"
//                 >
//                   <img
//                     src="/joker.png"
//                     alt="JOKERLUDO"
//                     className="header-logo-img"
//                   />
//                 </Link>

//               </div>

//               {/* =================================================
//                   RIGHT SIDE
//               ================================================= */}

//               <div className="header-right-group">

//                 {/* CASH WALLET PILL */}

//                 <NavLink
//                   exact
//                   to="/Addcase"
//                   className="wallet-chip-pill cash-pill"
//                 >
//                   <span className="pill-icon">
//                     💵
//                   </span>

//                   <div className="pill-text-col">

//                     <span className="pill-small-label">
//                       Cash
//                     </span>

//                     <span className="pill-val-num">
//                       {user &&
//                       user?.Wallet_balance !==
//                         undefined
//                         ? user.Wallet_balance
//                         : 0}
//                     </span>

//                   </div>
//                 </NavLink>

//                 {/* EARN / REFERRAL WALLET PILL */}

//                 <NavLink
//                   exact
//                   to="/redeem/refer"
//                   className="wallet-chip-pill earn-pill"
//                 >
//                   <span className="pill-icon pink-bag">
//                     💰
//                   </span>

//                   <div className="pill-text-col">

//                     <span className="pill-small-label">
//                       Earn
//                     </span>

//                     <span className="pill-val-num">
//                       {user &&
//                       user?.referral_wallet !==
//                         undefined
//                         ? user.referral_wallet.toFixed(
//                             2
//                           )
//                         : 0}
//                     </span>

//                   </div>
//                 </NavLink>

//               </div>
//             </div>

//           </React.Fragment>
//         ) : (
//           <div
//             className="w3-teal"
//             style={styles}
//           >
//             <div className="w3-container">

//               <div
//                 className={`${css.headerContainer} justify-content-between`}
//               >

//                 <Link to="/">
//                   <img
//                     src="/joker.png"
//                     className="snip-img"
//                     alt="LOGO"
//                     width="30px"
//                   />
//                 </Link>

//                 <Link
//                   type="button"
//                   className="login-btn"
//                   to="/login"
//                 >
//                   LOGIN
//                 </Link>

//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="bottom_menus_main">
//         <BottonMenu
//           w3_close={w3_close}
//         />
//       </div>
//     </>
//   );
// };

// export default Header;
